<template>
    <div>
        <!-- begin breadcrumb -->
        <ol class="breadcrumb float-xl-right">
            <li class="breadcrumb-item active"><a href="javascript:;">Entrega Equipos</a></li>
        </ol>
        <!-- end breadcrumb -->
        <!-- begin page-header -->
        <h1 class="page-header">Módulo Entrega Equipos</h1>
        <!-- end page-header -->
        <!-- begin panel -->
        <!-- <panel title="Panel Title here">
			Panel Content Here
		</panel> -->
        <!-- end panel -->
				<!-- begin card -->
				<div class="card  border-0 ">
					<div class="card-body">
						<button v-show="nuevoEntregaEquipo==0" type="button" class="btn btn-warning " @click="nuevoEntregaEquipo=1;nuevo=true"> <i class="fa fa-plus"></i> Nueva Entrega de Equipo </button> &nbsp;
						<button v-show="nuevoEntregaEquipo==1" type="button" class="btn btn-danger animated fadeIn" @click="nuevoEntregaEquipo=0"> <i class="fa fa-list"></i> Ver Entrega de Equipos </button>
					</div>
				</div>
        <!-- begin row -->
        <div class="row animated fadeIn" v-if="nuevoEntregaEquipo==0">
            <!-- begin col-12 -->
            <div class="col-xl-12">
				<registros :placeholder="'Buscar IMEI'" :ocultarEditar="true"  v-if="!proceso" :field="'Id'" :columns="columns2" @eliminar="confirmar($event)" @editar="nuevoEntregaEquipo=1;entregaEquipo={...$event};nuevo=false"  :url="this.URL_BASE()+'entrega_equipos_vendedor/search/'"/>
				<procesando v-if="proceso"/>
            </div>
            <!-- end col-12 -->
        </div>
        <!-- end row -->
            <!-- begin row -->
        <div class="row animated fadeIn" v-if="nuevoEntregaEquipo==1">
            <!-- begin col-12 -->
            <div class="col-xl-12">
                <equipo v-show="!proceso" @cancelar="nuevoEntregaEquipo=0" @actualizar="(actualizar($event))"  @guardar="(guardar($event))"     :registro="entregaEquipo" :nuevo="nuevo"  />
				<procesando v-show="proceso"/>
            </div>
            <!-- end col-12 -->

        </div>
        <!-- end row -->
    </div>
</template>
<script>
	import equipo from '../components/compartidos/principales/EntregaEquipo'
	import registros from '../components/compartidos/Registros'
	import procesando from '../components/compartidos/Procesando'
	import axios from 'axios'
	export default {
		name: "EntregaEquipo",
		components: {
			equipo,
			registros,
			procesando
		},
		created(){
			// this.loadItems() ;
		},
		data() {
			return {
            	proceso:false,
				nuevo:true,
				entregaEquipo:null,
				nuevoEntregaEquipo: 0,
				counter: 0,
				forms: [],
				detalles: [],
				totalRecords:0,
				serverParams: {
      				search:'',
     				sort: {
        				field: 'id', 
        				type: 'asc',
      				},
					page: 1, 
      				perPage: 10
    			},
				columns2: [
						{
						label: 'Vendedor',
						field: 'vendedor',
						width: '15%',
						thClass: 'text-nowrap',
						tdClass: 'text-nowrap'
					},
					{
						label: 'DNI-Vendedor',
						field: 'dni_vendedor',
						width: '10%',
						thClass: 'text-nowrap',
						tdClass: 'text-nowrap'
					},
					{
						label: 'IMEI',
						field: 'imei',
						width: '10%',
						thClass: 'text-nowrap',
						tdClass: 'text-nowrap'
					},
					{
						label: 'Modelo',
						field: 'modelo',
						width: '20%',
						thClass: 'text-nowrap',
						tdClass: 'text-nowrap'
					},
					{
						label: 'Precio Base',
						field: 'precio_base',
						width: '20%',
						thClass: 'text-nowrap',
						tdClass: 'text-nowrap'
					},
					{
						label: 'Detalle Equipo',
						rutaDetalle:'/entrega-detalle/equipo/',
						field: 'imei',
						width: '5%',
						thClass: 'text-nowrap',
						tdClass: 'text-nowrap',
					},
					
				
				
					{
						label: 'Creado el',
						field: 'fecha_registro',
						type: 'datetime',
						dateInputFormat: 'yyyy-MM-dd',
						dateOutputFormat: 'MMM do yy',
						width: '20%',
						tdClass: 'text-center text-nowrap',
						thClass: 'text-center text-nowrap'
					},
					
				]
			}
		},
		methods: {
			actualizar(registro){
				this.proceso=true;
			 axios.put(this.URL_BASE()+"entrega_equipos_vendedor/update/",registro).then(respuesta => {
            //   console.log(respuesta.data.msg)
				if(respuesta.data.msg=='exito'){
					this.exito("registrada correctamente");
				}
				this.proceso=false;
            }).catch( (error) =>{
              console.log("er store"+error);
            });
			},
			guardar(registro){
				this.proceso=true;
			 axios.post(this.URL_BASE()+"entrega_equipos_vendedor/create/",registro).then(respuesta => {
            //   console.log(respuesta.data.msg)
				if(respuesta.data.msg=='exito'){
					this.exito(" actualizada correctamente");
				}
				this.proceso=false;
            }).catch((error) =>{
              console.log("er store"+error);
            });
			},
		confirmar(registros){
			// let a = await this.confirmar();
			this.$swal({
            title: '¿Estás seguro?',
            text: '¡Los registros seleccionados se eliminarán!',
            type: 'warning',
            showCancelButton: true,
            buttonsStyling: false,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar',
            confirmButtonClass: 'btn m-r-5 btn-warning',
            cancelButtonClass: 'btn btn-default',
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.value) {
				this.eliminar(registros);
              // this.$swal('Proceso confirmado', '', 'success')
              return true;
            } else if (result.dismiss) {
              return false;
              // Swal.fire('Changes are not saved', '', 'info')
            }
          })
		},
		eliminar(registros){
			this.proceso=true;
			axios.post(this.URL_BASE()+"entrega_equipos_vendedor/delete",registros).then(respuesta => {
				if(respuesta.data.msg=='exito'){
					this.$swal('Proceso completado', '', 'success')
				}
				this.proceso=false;
			}).catch( (error)=> {
				console.log("er store"+error);
			});
		}
		    
		},
	}
</script>